import IconTwitter from '@picsart/icons/IconTwitter';
import IconFacebook from '@picsart/icons/IconFacebook';
import IconInstagram from '@picsart/icons/IconInstagram';
import IconYouTube from '@picsart/icons/IconYouTube';
import IconPinterest from '@picsart/icons/IconPinterest';

var externalLinksData = [{
  name: 'facebook',
  component: IconFacebook,
  url: 'https://www.facebook.com/picsart',
  dataTest: 'facebook-logo',
  ariaLabel: 'Facebook Icon'
}, {
  name: 'twitter',
  component: IconTwitter,
  url: 'https://twitter.com/picsart',
  dataTest: 'twitter-logo',
  ariaLabel: 'Twitter Icon'
}, {
  name: 'instagram',
  component: IconInstagram,
  url: 'https://www.instagram.com/picsart',
  dataTest: 'instagram-logo',
  ariaLabel: 'Instagram Icon'
}, {
  name: 'youtube',
  component: IconYouTube,
  url: 'https://www.youtube.com/picsart',
  dataTest: 'youtube-logo',
  ariaLabel: 'Youtube Icon'
}, {
  name: 'pinterest',
  component: IconPinterest,
  url: 'https://www.pinterest.com/picsart',
  dataTest: 'pinterest-logo',
  ariaLabel: 'Pinterest Icon'
}];

var changesNeedLocales = ['US'];

export { changesNeedLocales as c, externalLinksData as e };
//# sourceMappingURL=constants-058c946f.js.map
